<div class="export-file-wrapper">
  <button
    class="export-file-button"
    color="primary"
    [disabled]="disabled"
    (click)="onDownloadFile()"
    disableRipple
    mat-button
  >
    {{ type | uppercase }}
    <mat-icon>download</mat-icon>
  </button>
</div>
